import { IContainerMission } from '../interfaces/container-mission.interface';
import { Container } from './container.model';

export class ContainerMission extends Container implements IContainerMission {
  containermissionpk: string;
  containermissionLoadedDMDSQuantity: number;
  loadingstationName: string;
  productName: string;
  createdOn: string;
  createdBy: string;
  changedOn: string;
  changedBy: string;

  constructor(containerMission: IContainerMission) {
    super(containerMission);
    Object.keys(containerMission).map(key => this[key] = containerMission[key]);
  }

  get lastUpdatedBy(): string {
    return this.changedBy ? this.changedBy :
              this.createdBy ? this.createdBy : '';
  }

  get lastUpdatedOn(): string {
    return this.changedOn ? this.changedOn : this.createdOn;
  }

  get loadedQty(): number {
    return Math.floor(this.containermissionLoadedDMDSQuantity);
  }

  get limit(): number {
    return this.weightThreshold > this.containerMaxWeight ?
            this.containerMaxWeight :
            this.weightThreshold;
  }

  get isInError(): boolean {
    return this.containermissionLoadedDMDSQuantity > this.limit;
  }
}